import axios from 'axios';
import { useAuthStore } from './store/authStore';
import { useDialogStore } from './store/dialogStore';
import { useNavigate } from 'react-router-dom';

const axiosInstance = axios.create({
  // @ts-expect-error TS1343: The 'import.meta' meta-property is only allowed when the '--module' option is 'es2020', 'es2022', 'esnext', 'system', 'node16',
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const pendingRequests = new Map<string, number>();

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const currentTime = Date.now();
    const lastRequestTime = pendingRequests.get(config.url || '');

    if (lastRequestTime && currentTime - lastRequestTime < 2000) {
      console.warn('Duplicate request detected, skipping...');
      return Promise.reject('Duplicate request detected');
    }

    pendingRequests.set(config.url || '', currentTime);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    pendingRequests.delete(response.config.url || '');
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 503) {
        // Show Error503 component with maintenance message
        const message = data?.message || 'Service vorübergehend nicht verfügbar';
        console.log(message);

        const openDialog = useDialogStore.getState().openDialog;
        openDialog(`${message}`, () => {
          useDialogStore.getState().closeDialog();
        }, true);

        return Promise.reject('Service maintenance - Error503 shown');
      } else if (status === 401 && window.location.pathname !== '/') {
        const logout = useAuthStore.getState().logout;
        logout();
        const navigate = useNavigate();
        navigate('/');
        return Promise.reject('Unauthorized access - redirected to login.');
      } else if ([400, 500, 401].includes(status)) {
        const openDialog = useDialogStore.getState().openDialog;
        openDialog(`Error : ${data?.message || ''}`, () => {
          useDialogStore.getState().closeDialog();
        });
        return Promise.reject(`Error ${status}: ${data?.message || ''}`);
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
